import type { RouteRecordRaw } from 'vue-router';

// Error pages render full-bleed visuals; minimal layout suppresses
// sidebar / flashbar / trial banner. Both are authFree public error
// surfaces reachable by direct URL. Permission denial itself no longer
// redirects here — AppLayout renders the denied page in place (URL + chrome
// preserved); /401 stays as a standalone destination. legacy.ts's terminal
// record redirects every unmatched path to /404, and legacy's own catch-all
// forwards unmatched sub paths up the bridge onto the same records.
const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/404',
    name: 'not-found',
    component: () => import('@/domains/errors/NotFound.vue'),
    meta: { renderer: 'native', layout: 'minimal', authFree: true },
  },
  {
    path: '/401',
    name: 'unauthorized',
    component: () => import('@/domains/errors/Unauthorized.vue'),
    meta: { renderer: 'native', layout: 'minimal', authFree: true },
  },
];

export default errorRoutes;
